import { render, staticRenderFns } from "./doalogSlot.vue?vue&type=template&id=63dd6608&"
import script from "./doalogSlot.vue?vue&type=script&lang=ts&"
export * from "./doalogSlot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports